import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { GlobalStyles } from 'twin.macro';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';
import store from 'mrf/redux/store';
import { Provider } from 'react-redux';

// This import will initialize i18n support
import './i18n';
import { Spinner } from 'styles/components/Spinner';

import 'styles/tailwind.css';
import 'tippy.js/dist/tippy.css';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <Suspense fallback={<Spinner />}>
            <Provider store={store}>
                <GlobalStyles />
                <App />
            </Provider>
        </Suspense>
    </BrowserRouter>,
    rootElement);

